/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackChartPointViewModel } from "../types/FeedbackChartPointViewModel.ts";

export const feedbackChartPointViewModelSchema = z.object({
  category: z.string().nullish(),
  value: z.optional(z.number()),
  value2: z.number().nullish(),
  color: z.string().nullish(),
}) as unknown as ToZod<FeedbackChartPointViewModel>;
